$(document).ready(() => {

  if($('.js-iframe-lazy').length) {

    $('.js-iframe-lazy').each((i, e) => {

      if($(e).attr('data-delay') === undefined) {

        $(e).attr('src', $(e).attr('data-s'));

      }

    });

  }

});